//todas as URLs deste arquivos sao relacionadas à API: https://<host>/api/
export const urlValidateToken = 'validateToken'
export const urlLogin = 'login'
export const urlPrimeiroAcesso = "registrarPrimeiroAcesso";

export const urlServerTime = 'monitor/serverTime';
export const urlEquipmentData = 'monitor/equipmentData';
export const urlCompaniesEquipment = 'monitor/companiesEquipment';
export const urlNoSyncEquipment = 'monitor/noSyncEquipment';
export const urlMonitorRequestErrors = 'monitor/requestErrors';

export const urlUnidadesDeMedidas = 'unidadeMedidas';
export const urlTamanhosEVariacoes = 'variacoes';
export const urlCategorias = 'categorias';
export const urlProdutos = 'produtos';
export const urlProdutoFilho = 'produtoFilho';
export const urlProdutoEquipamento = 'produtosPorEquipamento';

export const urlEmpresas = "empresas";
export const urlDepartamentos = "departamentos";
export const urlAreas = 'areas';
export const urlFuncoes = 'funcoes';
export const urlSetores = 'setores';
export const urlContratos = 'contratos';
export const urlCentroCustos = 'centroCustos';
export const urlJustificativaRequisicao = 'justificativaRequisicao';
export const urlJustificativaDevolucao = 'justificativaDevolucao'
export const urlRetiradas = "/retiradas";
export const urlRetiradasStatistics = "/retiradas/statistics";
export const urlRetiradasExtras = "/retiradaExtra";
export const urlTipoDocumento = "/tipoDocumento";
export const urlRegimeTrabalho = "/regimeTrabalho";
export const urlProntuarios = "/prontuarios";
export const urlDevolucao = "/devolucao";

export const urlExportacao = "exportacao";
export const urlTiposExportacao = "tiposExportacao";
export const urlConfigEmpresa = "configEmpresa";
export const urlModulos = "modulos";
export const urlModuloEmpresa = "moduloEmpresa";

export const urlSessoes = "sessoes";

export const urlEquipamento = "equipamento";
export const urlConfigEquipamento = "configEquipamento";
export const urlArmarios = "armarios";
export const urlHistoricoEquipamentos = "historicoEquipamentos";
export const urlPontoEntrega = "pontoEntrega";
export const urlEstoque = "estoque";
export const urlDashboard = "dashboard";
export const urlDashboardInterna = "dashboard/sempher"

export const urlFichaEpiColaborador = "relatorios/fichaEpiColaborador";
export const urlSaldoEpisPessoa = "pessoas/buscarEpi ";
export const urlFichaEpiEmpresa = "relatorios/fichaEpiEmpresa";
export const urlFichaEpiEmpresaPDF = "relatorios/fichaEpiEmpresaPDF";
export const urlRelatorioAbastecimento = "relatorios/abastecimento";
export const urlSaldoMaquina = "relatorios/saldoMaquina";
export const urlSaldoArmario = "relatorios/saldoArmario";
export const urlRelatorioRetiradas = "relatorios/retiradas";
export const urlRelatorioPendenciasRetiradas = "relatorios/pendenciasRetiradas";
export const urlRelatorioPendencias = "relatorios/pendencias";
export const urlRelatorioRetiradasExtras = "relatorios/retiradasExtras";
export const urlSaidaProdutosFunc = "relatorios/saidaProdutosFunc";
export const urlSaidaProdutosFuncAgrupado = "relatorios/saidaProdutosFuncAgrupado";
export const urlRelatorioRetiradasFunc = "relatorios/retiradasFunc";
export const urlSaidaProdutos = "relatorios/saidaProdutos";
export const urlAbastecimentoRetiradas = "relatorios/abastecimentoRetiradas";
export const urlRelatorioGrupos = "relatorios/grupos";
export const urlRelatorioRetiradasOrigemExtra = "relatorios/retiradasOrigemExtra";

export const urlPessoas = "pessoas";

export const urlBuscaProdutoCodigo = 'produtos/buscarProduto';

export const urlGHEs = 'grupos';
export const urlPermissao = 'permissao';
export const urlGruposCategoria = 'gruposCategoria';

export const urlCategoriasEmpresa = 'categorias/categoriasEmpresa';

export const urlProdutosCategoria = 'categorias/:id/produtos';

export const urlConfigAlarme = 'configAlarme';
export const urlAlarmes = 'alarmes';
export const urlAlertas = 'alertas';

// rotas exclusivas adminSempher
export const urlHabilidades = "/ability";
export const urlRoles = "/roles";
export const urlRelatoriosExcelImport = "/relatoriosExcel/import";
export const urlRegistroLogs = "/logs";
export const urlRequestErrors = "/erroRequest";
export const urlSistemas = "/sistemas";
export const urlAlteracoes = "/alteracoes";
export const urlHistoricoAlteracoes = "/historico/alteracoes";

export const urlTutoriais = "/tutoriais";
export const urlProcessamentos = "/processamentos";